exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/**\n * To be used with CSS Modules rendered by the webpack.config.\n * Any styles specific to the User Module module should live here.\n * Import as neede like so:\n * ...\n * import userModuleStyles from 'userModuleModuleStyles.css';\n * ...\n * render() {\n *   return(\n *     <div styleName=\"user-module-item\">\n * ...\n */\n\n.modules-userModule-___userModuleModuleStyles__user-module-item___oG-rH {\n\n}\n", ""]);

// exports
exports.locals = {
	"user-module-item": "modules-userModule-___userModuleModuleStyles__user-module-item___oG-rH"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./modules/userModule/userModuleModuleStyles.css
// module id = 1367
// module chunks = 1